import VideoPlayer from './VideoPlayer';
import VideoHeader from './VideoHeader';
import "../css/VideoSection.css";

const VideoSection = ({ activeVideo, completionStatus, onMarkComplete }) => (
    <div className="vid-sect-fron-section">
        <div className="vid-sect-fron-player">
            {activeVideo ? (
                <>
                    <div className="vid-sect-fron-player__container">
                        <VideoPlayer
                            video={activeVideo}
                            isCompleted={completionStatus[activeVideo.id]}
                            onMarkComplete={onMarkComplete}
                        />
                    </div>
                    <VideoHeader
                        activeVideo={activeVideo}
                        completionStatus={completionStatus}
                        onMarkComplete={onMarkComplete}
                    />
                </>
            ) : (
                <EmptyVideoState />
            )}
        </div>
    </div>
);

const EmptyVideoState = () => (
    <div className="vid-sect-fron-player__empty">
        <div className="vid-sect-fron-empty-state">
            <div className="vid-sect-fron-empty-icon">📺</div>
            <h3>Select a Lesson</h3>
            <p>Choose a lesson from the course curriculum to start learning</p>
        </div>
    </div>
);

export default VideoSection;